//Helpers for the ?autologin=1 query parameter: integrations can link into METIS and
//skip the "Login via Keycloak" button. A sessionStorage timestamp guards against redirect loops.

export const AUTOLOGIN_PARAM = 'autologin';
export const AUTOLOGIN_ATTEMPT_KEY = 'autologinAttemptedAt';
export const AUTOLOGIN_GUARD_MS = 60 * 1000;

const OIDC_HASH_PARAMS = ['access_token', 'id_token', 'session_state', 'error'];

export function isOidcCallbackHash (hash) {
  if (!hash) {
    return false;
  }
  let params = new URLSearchParams(hash.replace(/^#/, ''));
  return params.has('state') && OIDC_HASH_PARAMS.some(param => params.has(param));
}

export function hasAutoLoginParam (search) {
  return new URLSearchParams(search || '').get(AUTOLOGIN_PARAM) === '1';
}

//removes the autologin param from a path like "/route?a=1&autologin=1#hash".
//Other params are kept byte-for-byte (no re-encoding); the path is returned unchanged if the param is absent.
export function stripAutoLoginParam (path) {
  if (!path) {
    return path;
  }
  let hashIndex = path.indexOf('#');
  let hash = hashIndex >= 0 ? path.slice(hashIndex) : '';
  let beforeHash = hashIndex >= 0 ? path.slice(0, hashIndex) : path;
  let queryIndex = beforeHash.indexOf('?');
  if (queryIndex < 0) {
    return path;
  }
  let pathname = beforeHash.slice(0, queryIndex);
  let parts = beforeHash.slice(queryIndex + 1).split('&');
  let kept = parts.filter(part => paramName(part) !== AUTOLOGIN_PARAM);
  if (kept.length === parts.length) {
    return path;
  }
  let rest = kept.filter(part => part !== '').join('&');
  return `${pathname}${rest ? `?${rest}` : ''}${hash}`;
}

function paramName (part) {
  let name = part.split('=')[0];
  try {
    return decodeURIComponent(name.replace(/\+/g, ' '));
  } catch (e) {
    return name;
  }
}

function readAttempt (storage) {
  try {
    return parseInt(storage.getItem(AUTOLOGIN_ATTEMPT_KEY), 10) || 0;
  } catch (e) {
    return 0;
  }
}

export function shouldAutoLogin ({ search, hash, storage = window.sessionStorage, now = Date.now() }) {
  if (!hasAutoLoginParam(search) || isOidcCallbackHash(hash)) {
    return false;
  }
  return now - readAttempt(storage) > AUTOLOGIN_GUARD_MS;
}

export function markAutoLoginAttempt (storage = window.sessionStorage, now = Date.now()) {
  try {
    storage.setItem(AUTOLOGIN_ATTEMPT_KEY, String(now));
  } catch (e) {
    // ignore storage errors
  }
}

export function clearAutoLoginAttempt (storage = window.sessionStorage) {
  try {
    storage.removeItem(AUTOLOGIN_ATTEMPT_KEY);
  } catch (e) {
    // ignore storage errors
  }
}
